/**
 * @generated SignedSource<<095ad5fee4fd687602d2c93201f1e22a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type FacilityType = "DINING" | "GOLF_COURSE" | "RACQUET" | "SIMULATOR";
import { FragmentRefs } from "relay-runtime";
export type FiltersModalFragment_facility$data = {
  readonly id: string;
  readonly name: string;
  readonly slug: string;
  readonly type: FacilityType;
  readonly " $fragmentSpreads": FragmentRefs<"AgendaDateSelectorControlFragment_facility" | "facilityToScheduleOption_facility">;
  readonly " $fragmentType": "FiltersModalFragment_facility";
};
export type FiltersModalFragment_facility$key = {
  readonly " $data"?: FiltersModalFragment_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"FiltersModalFragment_facility">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FiltersModalFragment_facility",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AgendaDateSelectorControlFragment_facility"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "facilityToScheduleOption_facility",
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Department",
          "kind": "LinkedField",
          "name": "department",
          "plural": false,
          "selections": [
            (v3/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Facility",
  "abstractKey": null
};
})();

(node as any).hash = "832608da35456bbd710222369d0ece36";

export default node;
